import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>Силуэт "трапеция" &mdash; перед больше спинки. Круглый ворот с отделкой из ткани изделия. Плотность 170 г/м<sup>2</sup>. Состав - хлопок 100%. Для первых двух триместров лучше взять футболку своего размера, а для последнего триместра на размер больше.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`maternity_tee`]
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
